export var sidePaddings = {
    default: 22,
    small: 19,
    large: 25,
    extraLarge: 28
};
export var heights = {
    default: 40,
    small: 33,
    large: 47,
    extraLarge: 54
};
//# sourceMappingURL=sizes.js.map